/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json
import api from '../../api'

const state = {
} 
const mutations = { 
} 
const getters = { 
}

const actions = {
  getRelease({ rootState }, opt) { // 公司id获取动态(商机)
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Release/GetAndChildrenByCompId?userId=${rootState.user.id}`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addRelease({ rootState }, opt) { // 添加动态(商机)
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/release`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delRelease({ rootState }, id) { // 删除动态(商机)
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/release?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getWeAppSmallCode({ rootState }, opt) { // 获取小程序码
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/WeAppSmallCode?targetType=2&targetId=${opt.id}&scene=${opt.releaseId}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getReleaseType({ rootState }, id) { // 获取商机类型
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/releaseType/GetByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delReleaseType({ rootState }, id) { // 删除商机
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/releaseType?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editReleaseType({ rootState, commit }, opt) { // 修改商机
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/releaseType`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addRelease({ rootState }, opt) { // 添加商机
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/releaseType`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}